import React, { useState } from "react";
import { MdOutlineArrowLeft } from "react-icons/md";

const About = ({
  text = "Introducing Smcooks Catering, where excellence in culinary artistry meets the convenience of catering. Elevate your events with the same nationally acclaimed flavors that have made Smcooks the country's best in Indian cuisine. Our catering service brings   the freshest and most authentic tastes to your special occasions,ensuring an unforgettable dining experience for your guests.",
  maxLength = 203,
}) => {
  const [showAll, setShowAll] = useState(false);

  const toggleShowAll = () => {
    setShowAll(!showAll);
  };
  return (
    <>
      <section class="text-gray-600 body-font ">
        <div class="container px-5 py-12 mx-auto">
          <div class="flex flex-wrap w-full ">
            <div class="lg:w-1/2 w-full ">
              <h1 class="sm:text-3xl text-2xl font-medium title-font mb-2 text-gray-900">
              Know About us
              </h1>
              <div class="h-1 w-20 bg-indigo-500 rounded"></div>
              <div className="flex  text-start">
                <MdOutlineArrowLeft className="lg:w-[25px] lg:h-[25px] " />
                <a href="/">
                  <p className="text-blue-700 ">Back</p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="text-gray-600 body-font lg:mt-[-100px]">
        <div class="container mx-auto flex px-5 py-24 md:flex-row flex-col items-center">
          <div class="lg:max-w-lg lg:w-full md:w-1/2 w-5/6 mb-10 md:mb-0">
            <img
              class="object-cover object-center rounded"
              alt="hero"
              src="https://source.unsplash.com/720x600/?catering,cooking"
            />
          </div>
          <div class="lg:flex-grow md:w-1/2 lg:pl-24 md:pl-16 flex flex-col md:items-start md:text-left items-center text-center">
            <h1 class="title-font sm:text-4xl text-3xl mb-4 font-medium text-gray-900">
              {" "}
              Welcome to Smcooks:
              <br /> Where Culinary Excellence Begins
            </h1>
            <div>
              {showAll ? <p>{text}</p> : <p>{text.slice(0, maxLength)}...</p>}
              <button
                onClick={toggleShowAll}
                class=" text-start   text-blue-800  underline text-lg"
              >
                {showAll ? "Read Less" : "Read More"}
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
